import React from "react"
import {connect} from "react-redux"
import HasDataBody from "../body/hasDataBody"
import NoDataBody from "../body/noDataBody"
import Jsonviewer from "../jsonviewer"
import Mdviewer from "../mdviewer"
import IndexStyles from "./list.less"
import classNames from "classnames"

const List = (props: any) => {
    const getPageLabelData = () => {
        switch (props.pageLabel) {
            case "result":
                return <HasDataBody />
            case "json":
                return <Jsonviewer />
            default:
                return <Mdviewer />
        }
    }
    const showTag = () => {
        if (props.status === "success") {
            return getPageLabelData()
        } else {
            return <NoDataBody status={props.status} />
        }
    }
    // props.recognitionArea.length + props.table.length + props.errorField.length === 0 ? (
    //     <NoDataBody />
    // ) : (
    //     getPageLabelData()
    // )
    return (
        <div className={classNames({[IndexStyles.listAreaNormal]: false, [IndexStyles.listAreaTable]: true})}>
            <div className={IndexStyles.modelTestNav}>
                <div
                    className={classNames(IndexStyles.navTitleBtn, {
                        [IndexStyles.navTitleBtnActive]: props.pageLabel === "result",
                    })}
                    onClick={() => {
                        props.dispatch({type: "setPageLabe", payload: "result"})
                    }}
                >
                    识别结果
                </div>
                {/* <div
                    className={classNames(IndexStyles.navTitleBtn, {
                        [IndexStyles.navTitleBtnActive]: props.pageLabel === "json",
                    })}
                    onClick={() => {
                        props.dispatch({type: "setPageLabe", payload: "json"})
                    }}
                >
                    JSON
                </div>
                <div
                    className={classNames(IndexStyles.navTitleBtn, {
                        [IndexStyles.navTitleBtnActive]: props.pageLabel === "md",
                    })}
                    onClick={() => {
                        props.dispatch({type: "setPageLabe", payload: "md"})
                    }}
                >
                    调用示例
                </div> */}
            </div>
            <div className={IndexStyles.allMessage1}>{showTag()}</div>
        </div>
    )
}
export default connect((state: any) => {
    return {
        status: state.status,
        pageLabel: state.pageLabel,
        recognitionArea: state.recognitionArea,
        errorField: state.errorField,
        table: state.table,
    }
})(List)
